var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAutoPlay = function SvgIconAutoPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#000",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.625 30.051c1.5.867 1.5 3.032 0 3.898l-14.25 8.227c-1.5.866-3.375-.217-3.375-1.949V23.773c0-1.732 1.875-2.815 3.375-1.949l14.25 8.227Z",
    fill: "#fff"
  })));
};
export default SvgIconAutoPlay;